export const NPM_PACKAGE_URL = 'https://www.npmjs.com/package';
const NPM_REGISTRY_URL = 'https://registry.npmjs.com';
export const REQUEST_URL = `https://corsmirror.com/v1?url=${NPM_REGISTRY_URL}`;
export const DEBOUNCE_DELAY_IN_MILLISECONDS = 300;
